"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sumBNs = void 0;
const constants_1 = require("../constants");
const sumBNs = (values) => values.reduce((acc, value) => acc.add(value), constants_1.ZERO_BN);
exports.sumBNs = sumBNs;
